import { render, staticRenderFns } from "./PlanUpgradeNotificationInSidebar.vue?vue&type=template&id=681bc1f6&"
import script from "./PlanUpgradeNotificationInSidebar.vue?vue&type=script&lang=js&"
export * from "./PlanUpgradeNotificationInSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports